export const defaultPositionData = [
    { col: 1, colSpan: 2, rowSpan: 3 },
    { col: 3, colSpan: 4, rowSpan: 4 },
    { col: 1, colSpan: 2, rowSpan: 3 },
    { col: 3, colSpan: 2, rowSpan: 2 },
    { col: 5, colSpan: 2, rowSpan: 2 },

    { col: 1, colSpan: 6, rowSpan: 5 },
    { col: 1, colSpan: 6, rowSpan: 5 },
    { col: 1, colSpan: 6, rowSpan: 5 },
    { col: 1, colSpan: 6, rowSpan: 5 },
    { col: 1, colSpan: 6, rowSpan: 6 },
    { col: 1, colSpan: 6, rowSpan: 3 },
    { col: 1, colSpan: 6, rowSpan: 3 },
];
export const defaultPositionDataSmall = [
    { col: 1, colSpan: 2, rowSpan: 4 },
    { col: 3, colSpan: 4, rowSpan: 5 },
    { col: 1, colSpan: 2, rowSpan: 4 },
    { col: 3, colSpan: 2, rowSpan: 3 },
    { col: 5, colSpan: 2, rowSpan: 3 },

    { col: 1, colSpan: 6, rowSpan: 4 },
    { col: 1, colSpan: 6, rowSpan: 4 },
    { col: 1, colSpan: 6, rowSpan: 4 },
    { col: 1, colSpan: 6, rowSpan: 4 },
    { col: 1, colSpan: 6, rowSpan: 6 },
    { col: 1, colSpan: 6, rowSpan: 4 },
    { col: 1, colSpan: 6, rowSpan: 4 },
];
export const machineDefaultPositionData = [
    { col: 1, colSpan: 2, rowSpan: 3 },
    { col: 3, colSpan: 4, rowSpan: 4 },
    { col: 1, colSpan: 2, rowSpan: 3 },
    { col: 3, colSpan: 2, rowSpan: 2 },
    { col: 5, colSpan: 2, rowSpan: 2 },

    { col: 1, colSpan: 6, rowSpan: 2 },
    { col: 1, colSpan: 6, rowSpan: 6 },
    { col: 1, colSpan: 6, rowSpan: 6 },
    { col: 1, colSpan: 6, rowSpan: 3 },
    { col: 1, colSpan: 6, rowSpan: 3 },
    { col: 1, colSpan: 6, rowSpan: 6 },
    { col: 1, colSpan: 6, rowSpan: 6 },
    { col: 1, colSpan: 6, rowSpan: 6 },
    { col: 1, colSpan: 6, rowSpan: 6 },
    { col: 1, colSpan: 3, rowSpan: 12 },
];
export const machineDefaultPositionDataSmall = [
    { col: 1, colSpan: 2, rowSpan: 4 },
    { col: 3, colSpan: 4, rowSpan: 5 },
    { col: 1, colSpan: 2, rowSpan: 4 },
    { col: 3, colSpan: 2, rowSpan: 3 },
    { col: 5, colSpan: 2, rowSpan: 3 },

    { col: 1, colSpan: 6, rowSpan: 2 },
    { col: 1, colSpan: 6, rowSpan: 6 },
    { col: 1, colSpan: 6, rowSpan: 6 },
    { col: 1, colSpan: 6, rowSpan: 3 },
    { col: 1, colSpan: 6, rowSpan: 3 },
    { col: 1, colSpan: 6, rowSpan: 6 },
    { col: 1, colSpan: 6, rowSpan: 6 },
    { col: 1, colSpan: 6, rowSpan: 6 },
    { col: 1, colSpan: 6, rowSpan: 6 },
    { col: 1, colSpan: 3, rowSpan: 12 },
];

export const tabStripPositionData = [
    { col: 1, colSpan: 6, rowSpan: 2 },
    { col: 1, colSpan: 6, rowSpan: 5 },

    { col: 1, colSpan: 6, rowSpan: 12 },
];

export const tabStripMachinePositionData = [
    { col: 1, colSpan: 6, rowSpan: 2 },
    { col: 1, colSpan: 6, rowSpan: 5 },

    { col: 1, colSpan: 6, rowSpan: 2 },
    { col: 1, colSpan: 6, rowSpan: 12 },
];